import React, { useEffect, useRef, useState } from 'react';
import { AppWindow, ArrowRight, Globe, Laptop, Mail, Megaphone, Phone, Send, ChevronDown, Eye, ArrowUpRight, MessageCircle, PenTool, BarChart2, Heart } from 'lucide-react';
import { Button } from '@radix-ui/themes';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import Typed from "typed.js";
import TestimonialsSection from '../components/testimonials/TestimonialsSection';
import { Link } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import SpriteScrollAnimation from '../components/home/PaperHome';

export default function AIPlatform() {

    return (
        <>
            <section className=''>
                <div className='rounded-xl p-4 md:p-8 border border-brand-orange bg-brand-dark-orange '>
                    <p className='text-xs font-semibold border border-brand-orange bg-black rounded-full py-1 px-3 w-fit uppercase'>Coming Soon</p>
                    <h2 className='text-3xl md:text-5xl mt-4 font-extrabold'>Bold Edge AI</h2>
                    <p className='text-brand-orange font-poppins mt-3'>
                        We're working on something game-changing.
                    </p>
                    <p className='font-poppins md:max-w-[50%] mt-1'>
                        Our upcoming AI-powered platform will help creators, agencies, and brands produce professional short-form videos in minutes, not hours.
                    </p>

                    <div className='p-6 mt-6 [&_*]:font-poppins rounded-lg bg-black border border-brand-orange'>
                        <h3 className='text-xl md:text-3xl font-extrabold'>Why It's Different</h3>
                        <p className='mt-2'>Bold Edge AI cuts down your editing time drastically.</p>
                        <p className=''>From importing clips <span className='text-brand-orange'>→</span> selecting the best moments <span className='text-brand-orange'>→</span> adding captions <span className='text-brand-orange'>→</span> matching your brand style</p>
                        <p className=''>AI does it all for you, fast and accurately.</p>

                        <h3 className='mt-3 font-semibold text-xl'>Speed Benefits You’ll Love:</h3>
                        <ul className='marker:text-brand-orange list-outside list-disc ml-4'>
                            <li className='mt-1'>Minutes, Not Hours – Go from shoot to post in record time.</li>
                            <li>One-Click Branding – Instantly apply your brand kit to every video.</li>
                            <li>Smart Automation – AI handles trimming, captions, hashtags, and trends.</li>
                        </ul>
                    </div>
                    <p className='font-poppins italic mt-4 md:mt-8'>Get ready. The future of fast, AI-powered content creation is just around the corner.</p>
                </div>
            </section >
        </>
    )

}
